/**
 * IBAN de agencia por empresa + auto-relleno / limpieza en señales.
 */
export const EMPRESAS_EXPEDIENTE = ["Vitalcasa", "ATP Viviendas"];

export const IBAN_EMPRESA = {
  Vitalcasa: "ES1221007673572200046405",
  "ATP Viviendas": "ES9521007673500200054634",
};

const IBANS_AGENCIA = new Set(Object.values(IBAN_EMPRESA));

export function ibanAgencia(empresa) {
  return IBAN_EMPRESA[empresa] || IBAN_EMPRESA.Vitalcasa;
}

function esIbanAgencia(v) {
  return IBANS_AGENCIA.has(String(v || "").replace(/\s/g, ""));
}

/** Rellena IBAN salida/entrada si interviene la agencia; limpia IBAN de agencia al cambiar rol. */
export function aplicarIbansAgencia({ entrega_tipo, recibe_tipo, iban_salida, iban_entrada, empresa }) {
  const iban = ibanAgencia(empresa);
  let salida = iban_salida ?? "";
  let entrada = iban_entrada ?? "";

  if (entrega_tipo === "agencia") salida = iban;
  else if (esIbanAgencia(salida)) salida = "";

  if (recibe_tipo === "agencia") entrada = iban;
  else if (esIbanAgencia(entrada)) entrada = "";

  return { iban_salida: salida, iban_entrada: entrada };
}

export function importesDesdeImporteUnico(importe, recibe_tipo) {
  const v = importe != null && importe !== "" ? String(importe) : "";
  return {
    importe_comprador: recibe_tipo === "comprador" ? v : "",
    importe_agencia: recibe_tipo === "agencia" ? v : "",
    importe_propietario: recibe_tipo === "propietario" ? v : "",
  };
}

export function importeUnicoDesdeSenal(s) {
  if (s.importe_comprador != null && s.importe_comprador !== "") return String(s.importe_comprador);
  if (s.importe_agencia != null && s.importe_agencia !== "") return String(s.importe_agencia);
  if (s.importe_propietario != null && s.importe_propietario !== "") return String(s.importe_propietario);
  return "";
}
